var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnimated = function SvgAnimated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1736,
    height: 764,
    fill: "none",
    viewBox: "0 0 1736 764"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7665_1206)",
    d: "M1602.65 88.873c-2.2-13.376-14.64-23.625-29.65-23.625s-27.45 10.252-29.65 23.629h-.35v4.252c0 15.39 13.43 27.87 30 27.87s30-12.48 30-27.873v-4.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_7665_1206)",
    d: "M1573 116.747c16.57 0 30-12.48 30-27.873S1589.57 61 1573 61s-30 12.48-30 27.874 13.43 27.873 30 27.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_7665_1206)",
    d: "M1573 111.146c13.24 0 23.97-9.975 23.97-22.272 0-12.3-10.73-22.271-23.97-22.271s-23.97 9.975-23.97 22.275c0 12.296 10.73 22.268 23.97 22.268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_7665_1206)",
    d: "M1573 68.936c12.82 0 23.29 9.344 23.94 21.104q.03-.581.03-1.162c0-12.3-10.73-22.275-23.97-22.275s-23.97 9.975-23.97 22.275c0 .386.01.776.04 1.162.64-11.76 11.11-21.104 23.93-21.104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_7665_1206)",
    d: "M1560.83 90.785c-.8-.109-1.57-.833-1.4-1.65l.17-.761c.04-.198.1-.39.2-.567.23-.375.59-.55 1.1-.6l4.07-.603c7.01-.518 6.27-3.915 7.3-6.54l1.62-4.853c.14-.656.54-1.027 1.25-1.027h1.23c.72 0 1.09.375.95 1.027l-.29 4.943c-.36 3.9.04 5.65 4.07 6.198l4.42.885s1.25.2 1.07 1.294l-.26 1.238a1.12 1.12 0 0 1-.38.652c-.2.166-.45.255-.71.251l-4.33.552c-4.09.37-5.19-.057-6.54 4.923l-1.74 6.214c-.09.653-.56 1.028-1.27 1.028h-1.72c-.71 0-1.05-.375-.94-1.028l.5-6.06c.21-3.877-1.18-4.444-4.57-4.905l-3.82-.637.02.018h-.01z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_7665_1206)",
    d: "M1680.3 538.746c-4.4-26.752-29.28-47.25-59.3-47.25s-54.9 20.505-59.3 47.258h-.7v8.505c0 30.78 26.86 55.74 60 55.74s60-24.96 60-55.748v-8.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_7665_1206)",
    d: "M1621 594.495c33.14 0 60-24.96 60-55.748S1654.14 483 1621 483s-60 24.96-60 55.747c0 30.788 26.86 55.748 60 55.748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_7665_1206)",
    d: "M1621 583.291c26.47 0 47.94-19.95 47.94-44.542 0-24.6-21.47-44.543-47.94-44.543-26.48 0-47.94 19.95-47.94 44.55 0 24.593 21.46 44.535 47.94 44.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_7665_1206)",
    d: "M1621 498.871c25.63 0 46.57 18.69 47.87 42.21.05-.772.07-1.552.07-2.325 0-24.6-21.47-44.55-47.94-44.55-26.48 0-47.94 19.95-47.94 44.55 0 .773.02 1.553.07 2.325 1.29-23.52 22.23-42.21 47.87-42.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_7665_1206)",
    d: "M1596.66 542.57c-1.6-.218-3.13-1.665-2.81-3.3l.35-1.523c.07-.396.21-.778.4-1.132.46-.75 1.17-1.103 2.2-1.2l8.14-1.208c14.02-1.035 12.54-7.83 14.59-13.08l3.24-9.705c.29-1.312 1.09-2.055 2.52-2.055h2.46c1.42 0 2.17.75 1.88 2.055l-.57 9.885c-.71 7.8.08 11.303 8.14 12.398l8.85 1.77s2.48.397 2.13 2.587l-.53 2.475a2.13 2.13 0 0 1-.75 1.306c-.4.331-.9.509-1.42.502l-8.66 1.102c-8.18.743-10.38-.112-13.07 9.848l-3.5 12.427c-.18 1.305-1.1 2.055-2.53 2.055h-3.45c-1.41 0-2.09-.75-1.87-2.055l1-12.12c.42-7.755-2.35-8.887-9.13-9.81l-7.64-1.275.03.038h-.01z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_7665_1206)",
    d: "m1227.95 92.377 4.95-18.475 18.48-4.951 13.52 13.523-4.95 18.475-18.47 4.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_7665_1206)",
    d: "m1232.56 91.136 3.71-13.856 13.87-3.726 10.15 10.161-3.71 13.856-13.87 3.726z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear_7665_1206)",
    d: "m1256.58 97.571 3.36 3.378-18.47 4.951 1.24-4.603z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_7665_1206)",
    d: "m1256.58 97.572 3.71-13.856 4.61-1.241-4.95 18.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_7665_1206)",
    d: "m1232.9 73.902 3.37 3.378-3.71 13.856-4.61 1.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_7665_1206)",
    d: "m1257.92 81.348-22.29 12.87-3.07-3.067 1.87-6.974 16.69-9.636z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01101E",
    d: "m1249 82.752-2.47-.66-2.68 10.008 2.47.66z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7665_1206)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_7665_1206)",
    d: "m1058.79 374.496 7.76-28.966 28.96-7.763 21.2 21.203-7.76 28.966-28.96 7.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear_7665_1206)",
    d: "m1066.01 372.552 5.82-21.725 21.75-5.842 15.91 15.932-5.82 21.724-21.75 5.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear_7665_1206)",
    d: "m1103.67 382.641 5.28 5.296-28.96 7.763 1.93-7.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear_7665_1206)",
    d: "m1103.67 382.641 5.82-21.724 7.22-1.946-7.76 28.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear_7665_1206)",
    d: "m1066.55 345.53 5.28 5.296-5.82 21.724-7.22 1.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear_7665_1206)",
    d: "m1105.78 357.181-34.95 20.179-4.82-4.809 2.93-10.91 26.17-15.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear_7665_1206)",
    d: "m1109.49 360.916-34.81 20.322-2.23-2.226 34.96-20.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear_7665_1206)",
    d: "m1099.56 350.959 14.37.8 5.34 7.43-9.78 1.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear_7665_1206)",
    d: "m1085.41 347.193-12.9-6.533-8.33 3.77 7.65 6.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear_7665_1206)",
    d: "m1075.95 382.484-14.43-.789-5.33-7.43 9.82-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear_7665_1206)",
    d: "m1069.65 358.985-12.55 6.184-.91 9.096 9.82-1.714z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear_7665_1206)",
    d: "m1090.06 386.291 12.88 6.503 8.33-3.77-7.6-6.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear_7665_1206)",
    d: "m1107.29 369.123 7.74 11.568-3.76 8.333-7.6-6.384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear_7665_1206)",
    d: "m1105.87 374.433 12.49-6.149.91-9.096-9.78 1.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear_7665_1206)",
    d: "m1068.2 364.392-7.78-11.63 3.76-8.332 7.65 6.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01101E",
    d: "m1091.76 359.4-3.86-1.035-4.21 15.69 3.86 1.035z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_linear_7665_1206)",
    d: "M207.302 644.746c-4.402-26.752-29.28-47.25-59.302-47.25s-54.9 20.505-59.302 47.258H88v8.505c0 30.78 26.865 55.74 60 55.74s60-24.96 60-55.748v-8.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear_7665_1206)",
    d: "M148 700.495c33.135 0 60-24.96 60-55.748S181.135 589 148 589s-60 24.96-60 55.747c0 30.788 26.865 55.748 60 55.748"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear_7665_1206)",
    d: "M148 689.291c26.475 0 47.94-19.95 47.94-44.542 0-24.6-21.465-44.543-47.94-44.543s-47.94 19.95-47.94 44.55c0 24.593 21.465 44.535 47.94 44.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear_7665_1206)",
    d: "M148 604.871c25.635 0 46.575 18.69 47.872 42.21.045-.772.068-1.552.068-2.325 0-24.6-21.465-44.55-47.94-44.55s-47.94 19.95-47.94 44.55c0 .773.022 1.553.075 2.325 1.29-23.52 22.222-42.21 47.865-42.21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear_7665_1206)",
    d: "M123.655 648.57c-1.597-.218-3.127-1.665-2.805-3.3l.353-1.523a3.8 3.8 0 0 1 .397-1.132c.458-.75 1.17-1.103 2.198-1.2l8.137-1.208c14.025-1.035 12.54-7.83 14.595-13.08l3.24-9.705c.285-1.312 1.095-2.055 2.52-2.055h2.46c1.425 0 2.167.75 1.882 2.055l-.57 9.885c-.712 7.8.075 11.303 8.138 12.398l8.85 1.77s2.482.397 2.13 2.587l-.525 2.475a2.18 2.18 0 0 1-2.175 1.808l-8.663 1.102c-8.174.743-10.379-.112-13.072 9.848l-3.495 12.427c-.18 1.305-1.102 2.055-2.527 2.055h-3.45c-1.418 0-2.093-.75-1.875-2.055l.997-12.12c.428-7.755-2.347-8.887-9.127-9.81l-7.643-1.275.038.038h-.015z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear_7665_1206)",
    d: "m431.038 86.124 15.024-56.07 56.06-15.027 41.035 41.044-15.024 56.07-56.059 15.027z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear_7665_1206)",
    d: "m445.012 82.357 11.268-42.053 42.092-11.308 30.8 30.84-11.268 42.052-42.093 11.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear_7665_1206)",
    d: "m517.905 101.888 10.223 10.252-56.059 15.026 3.743-13.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_linear_7665_1206)",
    d: "m517.905 101.888 11.268-42.053 13.98-3.766-15.024 56.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear_7665_1206)",
    d: "m446.062 30.054 10.223 10.252-11.268 42.052-13.979 3.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear_7665_1206)",
    d: "M521.988 52.65 454.33 91.714l-9.324-9.31 5.671-21.166 50.655-29.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01101E",
    d: "m494.899 56.912-7.476-2.003-8.138 30.372 7.476 2.003z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint52_linear_7665_1206)",
    d: "m250.574 76.217-5.233-19.53-19.527-5.235-14.293 14.296 5.233 19.53 19.527 5.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint53_linear_7665_1206)",
    d: "m245.703 74.906-3.925-14.648-14.661-3.939-10.728 10.742 3.925 14.648 14.661 3.938z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint54_linear_7665_1206)",
    d: "m220.315 81.708-3.561 3.571 19.526 5.234-1.303-4.866z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint55_linear_7665_1206)",
    d: "m220.313 81.708-3.924-14.648-4.87-1.311 5.233 19.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint56_linear_7665_1206)",
    d: "m245.341 56.686-3.561 3.57 3.925 14.649 4.869 1.311z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint57_linear_7665_1206)",
    d: "m218.889 64.542 23.566 13.606 3.248-3.243-1.971-7.356-17.648-10.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint58_linear_7665_1206)",
    d: "m216.39 67.06 23.47 13.703 1.5-1.501-23.571-13.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint59_linear_7665_1206)",
    d: "m223.086 60.347-9.694.539-3.594 5.01 6.592 1.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint60_linear_7665_1206)",
    d: "m232.628 57.808 8.693-4.405 5.618 2.541-5.16 4.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint61_linear_7665_1206)",
    d: "m239.003 81.603 9.731-.532 3.594-5.01-6.624-1.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint62_linear_7665_1206)",
    d: "m243.254 65.758 8.461 4.17.614 6.133-6.625-1.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint63_linear_7665_1206)",
    d: "m229.488 84.17-8.681 4.384-5.618-2.542 5.126-4.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint64_linear_7665_1206)",
    d: "m217.872 72.594-5.219 7.8 2.535 5.618 5.126-4.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint65_linear_7665_1206)",
    d: "m218.831 76.174-8.42-4.146-.614-6.132 6.592 1.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint66_linear_7665_1206)",
    d: "m244.23 69.404 5.243-7.842-2.535-5.618-5.159 4.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01101E",
    d: "m228.344 66.038 2.604-.698 2.835 10.579-2.604.698z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint67_linear_7665_1206)",
    d: "M636.91 351.333c3.096-6.533.754-14.804-5.828-19.362s-15.149-3.839-20.176 1.358l-.152-.106-1.292 1.865c-4.672 6.748-2.572 16.299 4.693 21.329s16.943 3.636 21.617-3.113l1.291-1.865z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint68_linear_7665_1206)",
    d: "M615.446 354.552c7.264 5.031 16.943 3.637 21.617-3.113s2.573-16.3-4.691-21.33c-7.264-5.031-16.943-3.637-21.617 3.113s-2.574 16.3 4.691 21.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint69_linear_7665_1206)",
    d: "M617.147 352.096c5.805 4.019 13.539 2.904 17.272-2.487 3.735-5.394 2.057-13.024-3.748-17.044-5.804-4.019-13.538-2.904-17.273 2.49-3.733 5.391-2.055 13.022 3.749 17.041"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint70_linear_7665_1206)",
    d: "M629.963 333.588c5.62 3.892 7.374 11.168 4.088 16.522q.191-.245.367-.5c3.735-5.393 2.058-13.025-3.747-17.045-5.804-4.019-13.538-2.904-17.273 2.49a9 9 0 0 0-.337.521c3.854-4.961 11.28-5.881 16.902-1.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint71_linear_7665_1206)",
    d: "M617.991 339.473c-.317-.29-.433-.84-.114-1.149l.309-.281q.114-.114.259-.188c.214-.095.424-.064.664.071l1.967.97c3.232 1.903 3.938.188 5.185-.651l2.184-1.636c.262-.245.552-.285.865-.068l.539.373c.312.217.361.494.101.737l-1.626 2.08c-1.34 1.602-1.699 2.489-.098 3.953l1.671 1.732s.484.464.075.891l-.491.463a.584.584 0 0 1-.751.066l-2.067-1.074c-1.905-1.078-2.259-1.6-4.361.175l-2.653 2.194c-.237.258-.553.283-.866.067l-.756-.524c-.311-.215-.345-.482-.099-.735l2.058-2.506c1.271-1.635.835-2.305-.511-3.536l-1.482-1.44.002.014-.003-.003z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint72_linear_7665_1206)",
    d: "M59.651 150.873C57.45 137.497 45.011 127.248 30 127.248S2.55 137.501.349 150.877H0v4.252c0 15.39 13.433 27.87 30 27.87 16.568 0 30-12.48 30-27.873v-4.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint73_linear_7665_1206)",
    d: "M30 178.747c16.568 0 30-12.48 30-27.873S46.568 123 30 123 0 135.48 0 150.874s13.433 27.873 30 27.873"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint74_linear_7665_1206)",
    d: "M30 173.146c13.238 0 23.97-9.975 23.97-22.272 0-12.3-10.732-22.271-23.97-22.271s-23.97 9.975-23.97 22.275c0 12.296 10.733 22.268 23.97 22.268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint75_linear_7665_1206)",
    d: "M30 130.936c12.818 0 23.288 9.345 23.937 21.105q.033-.582.033-1.163c0-12.3-10.732-22.275-23.97-22.275s-23.97 9.975-23.97 22.275q0 .58.038 1.163c.645-11.76 11.111-21.105 23.932-21.105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint76_linear_7665_1206)",
    d: "M17.828 152.785c-.8-.109-1.564-.833-1.403-1.65l.176-.761a1.9 1.9 0 0 1 .199-.567c.229-.375.585-.551 1.099-.6l4.069-.603c7.012-.518 6.27-3.915 7.297-6.54l1.62-4.853c.142-.656.547-1.027 1.26-1.027h1.23c.712 0 1.084.375.941 1.027l-.285 4.943c-.356 3.9.038 5.651 4.069 6.198l4.425.885s1.241.199 1.065 1.294l-.263 1.238a1.085 1.085 0 0 1-1.087.903l-4.331.552c-4.088.371-5.19-.057-6.536 4.923l-1.748 6.214c-.09.653-.551 1.028-1.264 1.028h-1.725c-.709 0-1.046-.375-.937-1.028l.498-6.06c.214-3.877-1.173-4.444-4.563-4.905l-3.822-.637.02.018h-.008z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7665_1206",
    x1: 1556.35,
    x2: 1604.81,
    y1: 55.123,
    y2: 171.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7665_1206",
    x1: 1555.45,
    x2: 1637.92,
    y1: 71.65,
    y2: 153.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7665_1206",
    x1: 1596.97,
    x2: 1475.92,
    y1: -63.953,
    y2: 289.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7665_1206",
    x1: 1557.58,
    x2: 1604.65,
    y1: 140.872,
    y2: 38.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7665_1206",
    x1: 1544.39,
    x2: 1593.18,
    y1: 159.56,
    y2: 26.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7665_1206",
    x1: 1587.7,
    x2: 1684.62,
    y1: 471.246,
    y2: 703.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7665_1206",
    x1: 1585.91,
    x2: 1750.84,
    y1: 504.3,
    y2: 667.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7665_1206",
    x1: 1668.95,
    x2: 1426.85,
    y1: 233.093,
    y2: 939.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7665_1206",
    x1: 1590.15,
    x2: 1684.31,
    y1: 642.744,
    y2: 438.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7665_1206",
    x1: 1563.78,
    x2: 1661.35,
    y1: 680.12,
    y2: 414.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7665_1206",
    x1: 1224.34,
    x2: 1271.03,
    y1: 54.214,
    y2: 124.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7665_1206",
    x1: 1250.19,
    x2: 1327.38,
    y1: 92.643,
    y2: 199.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7665_1206",
    x1: 1201.66,
    x2: 1264.88,
    y1: 74.126,
    y2: 110.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7665_1206",
    x1: 1227.32,
    x2: 1262.37,
    y1: 83.609,
    y2: 91.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7665_1206",
    x1: 1224.27,
    x2: 1265.71,
    y1: 78.915,
    y2: 107.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7665_1206",
    x1: 1216.17,
    x2: 1265.89,
    y1: 64.136,
    y2: 101.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED892F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7665_1206",
    x1: 1053.11,
    x2: 1126.32,
    y1: 314.661,
    y2: 424.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7665_1206",
    x1: 1093.66,
    x2: 1214.68,
    y1: 374.914,
    y2: 542.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7665_1206",
    x1: 1017.56,
    x2: 1116.69,
    y1: 345.882,
    y2: 403.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7665_1206",
    x1: 1057.79,
    x2: 1112.76,
    y1: 360.75,
    y2: 373.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7665_1206",
    x1: 1053.01,
    x2: 1118.01,
    y1: 353.388,
    y2: 397.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA3A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7665_1206",
    x1: 1088.22,
    x2: 1059.09,
    y1: 358.425,
    y2: 391.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFEF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7665_1206",
    x1: 1095.49,
    x2: 1066.37,
    y1: 364.773,
    y2: 398.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFEF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7665_1206",
    x1: 1108.25,
    x2: 1173.49,
    y1: 353.79,
    y2: 401.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7665_1206",
    x1: 1076.45,
    x2: 996.009,
    y1: 345.284,
    y2: 353.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7665_1206",
    x1: 1060.9,
    x2: 1066.52,
    y1: 394.906,
    y2: 376.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7665_1206",
    x1: 1068.52,
    x2: 1042.86,
    y1: 346.885,
    y2: 427.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7665_1206",
    x1: 1095.08,
    x2: 1100.83,
    y1: 405.616,
    y2: 387.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7665_1206",
    x1: 1115.23,
    x2: 1089.63,
    y1: 362.091,
    y2: 442.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7665_1206",
    x1: 1081.04,
    x2: 1122.16,
    y1: 328.424,
    y2: 378.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7665_1206",
    x1: 1112.88,
    x2: 1051.99,
    y1: 336.849,
    y2: 359.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7665_1206",
    x1: 114.7,
    x2: 211.623,
    y1: 577.246,
    y2: 809.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7665_1206",
    x1: 112.907,
    x2: 277.84,
    y1: 610.3,
    y2: 773.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7665_1206",
    x1: 195.947,
    x2: -46.153,
    y1: 339.093,
    y2: 1045.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7665_1206",
    x1: 117.152,
    x2: 211.307,
    y1: 748.744,
    y2: 544.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7665_1206",
    x1: 90.775,
    x2: 188.35,
    y1: 786.12,
    y2: 520.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7665_1206",
    x1: 420.056,
    x2: 561.76,
    y1: -29.698,
    y2: 183.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7665_1206",
    x1: 498.524,
    x2: 732.779,
    y1: 86.93,
    y2: 410.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7665_1206",
    x1: 351.224,
    x2: 543.105,
    y1: 30.734,
    y2: 142.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7665_1206",
    x1: 429.099,
    x2: 535.5,
    y1: 59.513,
    y2: 84.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7665_1206",
    x1: 419.85,
    x2: 545.618,
    y1: 45.266,
    y2: 131.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01101E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7665_1206",
    x1: 395.26,
    x2: 546.159,
    y1: 0.415,
    y2: 112.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED892F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7665_1206",
    x1: 254.4,
    x2: 205.041,
    y1: 35.873,
    y2: 110.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7665_1206",
    x1: 227.064,
    x2: 145.464,
    y1: 76.498,
    y2: 189.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7665_1206",
    x1: 278.373,
    x2: 211.537,
    y1: 56.924,
    y2: 95.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7665_1206",
    x1: 251.246,
    x2: 214.184,
    y1: 66.948,
    y2: 75.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7665_1206",
    x1: 254.471,
    x2: 210.647,
    y1: 61.985,
    y2: 92.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA3A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7665_1206",
    x1: 230.731,
    x2: 250.37,
    y1: 65.381,
    y2: 87.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFEF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7665_1206",
    x1: 225.826,
    x2: 245.46,
    y1: 69.661,
    y2: 92.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFFEF4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7665_1206",
    x1: 217.227,
    x2: 173.235,
    y1: 62.255,
    y2: 94.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7665_1206",
    x1: 238.669,
    x2: 292.903,
    y1: 56.52,
    y2: 62.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7665_1206",
    x1: 249.15,
    x2: 245.361,
    y1: 89.978,
    y2: 77.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7665_1206",
    x1: 244.015,
    x2: 261.311,
    y1: 57.6,
    y2: 112.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7665_1206",
    x1: 226.106,
    x2: 222.226,
    y1: 97.199,
    y2: 84.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7665_1206",
    x1: 212.52,
    x2: 229.776,
    y1: 67.853,
    y2: 122.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7665_1206",
    x1: 235.572,
    x2: 207.845,
    y1: 45.153,
    y2: 78.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_7665_1206",
    x1: 214.103,
    x2: 255.159,
    y1: 50.833,
    y2: 66.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8491B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_7665_1206",
    x1: 626.856,
    x2: 612.897,
    y1: 322.477,
    y2: 388.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_7665_1206",
    x1: 621.445,
    x2: 632.887,
    y1: 329.451,
    y2: 390.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_7665_1206",
    x1: 680.823,
    x2: 520.462,
    y1: 282.599,
    y2: 400.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_7665_1206",
    x1: 601.359,
    x2: 653.008,
    y1: 360.447,
    y2: 329.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_7665_1206",
    x1: 589.901,
    x2: 651.623,
    y1: 364.637,
    y2: 321.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_7665_1206",
    x1: 13.35,
    x2: 61.811,
    y1: 117.123,
    y2: 233.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_7665_1206",
    x1: 12.454,
    x2: 94.92,
    y1: 133.65,
    y2: 215.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_7665_1206",
    x1: 53.974,
    x2: -67.076,
    y1: -1.953,
    y2: 351.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_7665_1206",
    x1: 14.576,
    x2: 61.654,
    y1: 202.872,
    y2: 100.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1903"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_7665_1206",
    x1: 1.388,
    x2: 50.175,
    y1: 221.56,
    y2: 88.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3406"
  })))));
};
export default SvgAnimated;